import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import AmenitiesPropertyGroup from '../../../components/PropertyGroup/AmenitiesPropertyGroup';
import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

/**
 * This component is used to render the amenities section of the listing page.
 * @param {object} props
 * @param {object} props.options - Options for the amenities property group.
 * @param {Array<string>} props.amenities - Selected amenities.
 * @returns {React.JSX.Element|null}
 */

const SectionAmenitiesMaybeComponent = ({ options, amenities = [] }) => {
  // Combine checks for publicData and selectedOptions.length
  const selectedOptions = amenities ?? [];
  if (selectedOptions.length === 0) {
    return null;
  }

  return (
    <ListingSection>
      <ListingSectionItem
        params={{
          sx: { justifyContent: { xs: 'center', sm: 'flex-start' } },
        }}
      >
        <Typography
          component="h3"
          mb={2}
          sx={{ textAlign: { xs: 'center', sm: 'left' } }}
          variant="h4"
        >
          <FormattedMessage id="ListingPage.featuresTitle" />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem
        params={{
          sx: { textAlign: { xs: 'center', sm: 'left' } },
        }}
      >
        <AmenitiesPropertyGroup
          id="ListingPage.amenities"
          options={options}
          selectedOptions={selectedOptions}
          showNotSelectedItems={true}
        />
      </ListingSectionItem>
    </ListingSection>
  );
};

SectionAmenitiesMaybeComponent.displayName = 'SectionAmenitiesMaybe';

const SectionAmenitiesMaybe = memo(SectionAmenitiesMaybeComponent);

export default SectionAmenitiesMaybe;
